import { Sensor } from 'oas';

/** transform the single element sensor array response to a sensor  */
export const transformSensorData = (sensorArray: Sensor[]): Sensor => sensorArray?.[0];
